module.exports = __webpack_public_path__ + "81aeef4cd7546f72f6236c06e5da03b0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/flower-white.png
// module id = 2809
// module chunks = 0